export enum PartnersTypeEnum {
  CORPORATE = 'corporate',
  PRIVATE = 'private',
  GENERAL = 'general',
}
